const AmityCourseData = {
    coursefee: "Yes",
    hostelfee: "Yes",
};
export default AmityCourseData;
